var map = {
	"./account.js": "168f",
	"./db.js": "74ae",
	"./i18n.js": "4be3",
	"./layout.js": "a3da",
	"./log.js": "4f03",
	"./menu.js": "daa7",
	"./page.js": "edb5",
	"./user.js": "db39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff7f";